"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@headlessui/react");
const useOnClickOutside_1 = __importDefault(require("../../../hooks/useOnClickOutside"));
const clsx_1 = __importDefault(require("clsx"));
const DropdownContainer = ({ children, className = 'w-48', triggerElement, }) => {
    const [show, setShow] = react_1.useState(false);
    const dropdownRef = react_1.useRef(null);
    useOnClickOutside_1.default(dropdownRef, () => setShow(false));
    return (react_1.default.createElement("div", { ref: dropdownRef, className: "relative" },
        react_1.default.cloneElement(triggerElement, { onClick: () => setShow(!show) }),
        react_1.default.createElement("div", { className: 'absolute z-10 right-0' },
            react_1.default.createElement(react_2.Transition, { show: show, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" }, (ref) => (react_1.default.createElement("div", { ref: ref, className: clsx_1.default('dark:bg-black-800 bg-gray-100 rounded-md shadow-lg origin-top-right', className), onClick: () => setShow(false) }, children))))));
};
exports.default = DropdownContainer;
